module.exports = __webpack_public_path__ + "assets/img/profile-connections-old.74984dd9.svg";